/** Loaded in the head, before the stylesheet paints: the theme without a flash. */
import { applyTheme, initialTheme } from './theme';

applyTheme(initialTheme());
